import React from 'react';
import { Link } from 'react-router-dom';

const ManageItem = ({ product, handleDelete }) => {
    const { _id, name, price, img, quantity, supplier, description, email } = product;



    return (
        <div className="col-md-4">

            <div style={{ height: '380px' }} class="shadow p-2 mb-3 bg-body rounded">
                <img style={{ height: '130px' }} src={img} alt="" />
                <h6 className='mt-2'>{name}</h6>
                <p class='m-0'>Price: ${price}</p>
                <p class='m-0'>Quantity: {quantity}</p>
                <p class='m-0'>Supplier: {supplier}</p>
                <p class='m-0'>Email: {email}</p>
                <p style={{ fontSize: '13px', textAlign: 'justify' }} class='m-0 mt-2'>{description}</p>

                <button onClick={() => handleDelete(_id)} className='btn btn-primary text-white mt-1'>Delete
                </button>
            </div>
        </div >

    );
};

export default ManageItem;